module.exports = __webpack_public_path__ + "83bbb16ebd9d6d98ecbe980b032394e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ss/ss24.jpg
// module id = 730
// module chunks = 0